import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { PrivateRoute } from './components/PrivateRoute';
import { Layout } from './components/Layout';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { InstancesListPage } from './pages/InstancesListPage';
import { InstanceDetailPage } from './pages/InstanceDetailPage';
import { MonitoringPage } from './pages/MonitoringPage';
import { InstanceDashboardPage } from './pages/InstanceDashboardPage';
import { ProfilePage } from './pages/ProfilePage';
import { SignUpPage } from './pages/SignUpPage';
import { CheckOutPage } from './pages/CheckOutPage';
import { BillingPage } from './pages/BillingPage';
import { InvoiceDetailPage } from './pages/InvoiceDetailPage';
import './App.css';
import './styles/shared.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Layout>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signUp" element={<SignUpPage />}/>
            <Route 
              path="/dashboard" 
              element={
                <PrivateRoute>
                  <DashboardPage />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/instances" 
              element={
                <PrivateRoute>
                  <InstancesListPage />
                </PrivateRoute>
              } 
            />
            <Route
              path="/instances/:instanceId"
              element={
                <PrivateRoute>
                  <InstanceDetailPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/instances/:instanceId/dashboard"
              element={
                <PrivateRoute>
                  <InstanceDashboardPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/instances/:instanceId/monitoring"
              element={
                <PrivateRoute>
                  <MonitoringPage />
                </PrivateRoute>
              }
            />
            <Route 
              path="/profile" 
              element={
                <PrivateRoute>
                  <ProfilePage />
                </PrivateRoute>
              } 
            />
            <Route
              path="/checkout"
              element={
                <PrivateRoute>
                  <CheckOutPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/billing"
              element={
                <PrivateRoute>
                  <BillingPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/invoices/:invoiceId"
              element={
                <PrivateRoute>
                  <InvoiceDetailPage />
                </PrivateRoute>
              }
            />
            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </Layout>
      </Router>
    </AuthProvider>
  );
}

export default App;
